import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

export function AppWrapperImpl({ loaded, children, alwaysRender }) {
  if (loaded) {
    return (
      <div>
        {children}
        {alwaysRender}
      </div>
    );
  }
  return <div>{alwaysRender}</div>;
}

AppWrapperImpl.propTypes = {
  loaded: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  alwaysRender: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};
AppWrapperImpl.defaultProps = {
  children: [],
  alwaysRender: [],
};

export function mapStateToProps(state) {
  return {
    loaded: _.negate(_.isNil)(state.user.id),
  };
}

// don't check for coverage of these mapping functions because it is really annoying
/* istanbul ignore next */
export default withRouter(connect(mapStateToProps)(AppWrapperImpl));
